import React from 'react';

import { Typography } from '@mui/material';
import { styled } from '@mui/material';

import { useUserInfoContext } from '~/context/UserInfoProvider';
import useIsSsku from '~/hooks/tenant/useIsSsku';
import useTenantTranslation from '~/hooks/useTenantTranslation';

const Disclaimer = () => {
  const isSsku = useIsSsku();
  const { t } = useTenantTranslation();
  const { userInfo } = useUserInfoContext();
  const disclaimer = isSsku
    ? t('page.video.summaryDisclaimer')
    : userInfo?.company?.video_disclaimer;

  if (!disclaimer) {
    return;
  }

  return <StyledText>{disclaimer}</StyledText>;
};

export default Disclaimer;

const StyledText = styled(Typography)`
  font-style: italic;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.common.text.secondaryToPrimary};
`;
